export const LOGIN_ERROR_MESSAGES = {
	EMPTY_IDENTIFER: 'Please enter your email or mobile number to proceed',
	INVALID_IDENTIFER: 'Please enter a valid email or mobile number',
	EMPTY_MOBILE: 'Please enter your mobile number to proceed',
	INVALID_MOBILE: 'Please enter a valid mobile number',
	EMPTY_PASSWORD: 'Please enter your password',
	WRONG_PASSWORD: 'Incorrect password. Kindly try again',
	INVALID_LOGIN: 'Unable to find your account. Please try again',
	EMPTY_OTP: 'Please enter the OTP to proceed',
	INVALID_OTP: 'Entered OTP is incorrect. Kindly try again',
	WRONG_OTP: 'Verification failed. Please check your OTP.',
	OTP_EXPIRED: 'Your OTP has expired. Kindly request for a new OTP',
	USER_UNAVAILABLE:
		'Unable to find your account. Please enter a valid mobile number',
}

export const SIGNUP_ERROR_MESSAGES = {
	EMPTY_NAME: 'Please enter the mandatory details to proceed',
	EMPTY_MOBILE: 'Kindly enter your Mobile Number to proceed',
	INVALID_MOBILE: 'Please enter a valid mobile number',
	EMPTY_EMAIL: 'Kindly enter your email address',
	INVALID_EMAIL: 'Please enter a valid email address',
}

export const SUBMIT_TYPE = {
	LOGIN: 'LOGIN',
	FORGOT: 'FORGOT',
	LOGIN_WITH_OTP: 'OTP',
	LOGIN_COSTING: 'LOGIN_COSTING', //used to categorize the login type for segments tracking api call
	SIGNUP: 'SIGNUP',
	SIGNUP_COSTING: 'SIGNUP_COSTING',
}

export const AUTH_DATA = 'AUTH_DATA'
export const AUTH_SIGNUP_ERROR = 'AUTH_SIGNUP_ERROR'
export const AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR'
export const AUTH_RESET_PASSENGER_INFO = 'AUTH_RESET_PASSENGER_INFO'
export const AUTH_RESET_DEFAULT_LOGIN = 'AUTH_RESET_DEFAULT_LOGIN'
